import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
	actions: {
		flexDirection: 'column',
		alignItems: 'flex-start',
		marginTop: 'auto',
		'& > * + *': {
			marginLeft: 0,
		},
	},
	buttonIcon: {
		marginRight: theme.spacing(1),
	},
	resetButton: {
		textAlign: 'left',
	},
}));
